import React from 'react'
import Dropdown from '../Dropdown'
import { HelpHeaderTitle, HelpValue, NotificationDropdownShell } from './help-utils'
import { HelpIcon } from '../../icons/HelpIcon'
import Docs from '../../icons/nav/Docs'
import { GuideIcon } from '../../icons/GuideIcon'
import { TelegramIcon } from '../../icons/TelegramIcon'
import { SlackIcon } from '../../icons/SlackIcon'

export interface HelpDropdownProps {
  onClickHelpIcon: () => void
  setNotificationsCloseFn: (fn: () => void) => void
  notificationsCloseFn: () => void
}

const HelpDropdown = ({
  onClickHelpIcon,
  setNotificationsCloseFn, notificationsCloseFn
}: HelpDropdownProps): JSX.Element => {
  return (
    <Dropdown
      onClick={onClickHelpIcon}
      transparent
      noChevron
      preferredAlignment='right'
      innerStyle={{ maxHeight: '75vh' }}
      onClose={() => {}}
      onCloseFn={fn => setNotificationsCloseFn(() => fn)}
      selectedContent={
        <HelpIcon style={{ height: 18, width: 18 }} strokeWidth="2" />
      }
      dropdownContent={
        <NotificationDropdownShell>
          <HelpHeaderTitle>Need Help?</HelpHeaderTitle>
          <HelpValue href='https://docs.radom.com/api/' target='_blank' rel='noopener noreferrer'>
            <div style={{ width: 20 }}>
              <Docs fill="#747894" width="17" height="18"/>
            </div>
            View our API documentation
          </HelpValue>
          <HelpValue href='https://docs.radom.com/guides' target='_blank' rel='noopener noreferrer'>
            <div style={{ width: 20 }}>
              <GuideIcon width="20" height="18" strokeWidth="1.2"/>
            </div>
            Read our guides
          </HelpValue>
          <HelpHeaderTitle>Contact Us</HelpHeaderTitle>
          <HelpValue href='https://t.me/radomcustomersupport' target='_blank' rel='noopener noreferrer'>
            <TelegramIcon/>
            Speak with us on Telegram
          </HelpValue>
          <HelpValue href='mailto:eryk@radom.com?subject=Slack channel request'>
            <SlackIcon/>
            Request a Slack channel
          </HelpValue>
        </NotificationDropdownShell>
      }
    />
  )
}

export default HelpDropdown
